import React, {useState} from 'react';
import styled from "@emotion/styled";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Icon from "@material-ui/core/Icon";
import {PropTypes} from 'prop-types';
// import {createMuiTheme, MuiThemeProvider} from "@material-ui/core";
// import makeStyles from "@material-ui/core/styles/makeStyles";


// const theme = createMuiTheme({
//     overrides: {
//         MuiTablePagination: {
//             root: {
//                 background: "gray",
//                 border: "10px black",
//                 borderRadius: "8px",
//                 margin: "3px",
//             }
//         }
//     }
// });

const Container = styled.div`
    box-sizing: border-box;
    
    background: var(--color-gray-100);

    border: 1px solid #CBD5E0;
    border-radius: 4px;
    height: 32px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-content: center;
    
    // text
    font-family: Metropolis,serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    
    color: black;
`;

const Divider = styled.div`
    height: 100%;
    width: 1px ;
    background: #E2E1E1;
 `;

function Pagination(props) {
    const {page, count, rowsPerPage, onChangePage, onRowsPerPageChange} = props;

    const backButtonDisabled = (page - 1) < 0;
    const nextButtonDisabled = (page + 1) * rowsPerPage >= count;

    const handleOnPageDecrementClick = (e) => {
        if (e) e.preventDefault();
        onChangePage(page - 1);
    };

    const handleOnPageIncrementClick = (e) => {
        if (e) e.preventDefault();
        onChangePage(page + 1);
    };


    return (
        <Container>

            <IconButton
                size={"small"}
                disabled={backButtonDisabled}
                style={{margin: "0 4px"}}
                onClick={handleOnPageDecrementClick}
            >
                <Icon fontSize={"small"}>navigate_before</Icon>
            </IconButton>

            <PageLabel page={page} rowsPerPage={rowsPerPage} count={count}/>

            <IconButton
                size={"small"}
                disabled={nextButtonDisabled}
                style={{margin: "0 4px"}}
                onClick={handleOnPageIncrementClick}
            >
                <Icon fontSize={"small"}>navigate_next</Icon>
            </IconButton>

            <Divider/>

            <RowsPerPageDropDown
                rowsPerPageOptions={[5, 10, 20]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageSelected={onRowsPerPageChange}
            />
        </Container>

    )
}


Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onRowsPerPageChange: PropTypes.func.isRequired
};


function PageLabel(props) {
    const {page, rowsPerPage, count} = props;
    const pageStartingRow = page * rowsPerPage + 1;
    const pageEndingRow = (page + 1) * rowsPerPage;

    const blank = "0 to 0 of 0";
    const pagesCount = Math.ceil(count/rowsPerPage);

    const LabelContainer = styled.div`
        display: flex;
        align-items: center;
        margin: 0 4px
    `;

    return (
        <LabelContainer>
            {/*{!count ? blank :*/}
            {/*    `${pageStartingRow}-${pageEndingRow < count ? pageEndingRow : count} of ${count}`*/}
            {/*}*/}
            {!count ? blank :
                `${page + 1} of ${pagesCount}`
            }
        </LabelContainer>
    )
}

const RowsDropDownContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 50px;
    align-content: center  
`;

function RowsPerPageDropDown(props) {
    const {rowsPerPage, rowsPerPageOptions, onRowsPerPageSelected} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    // determine the inital index
    const initialIndex = rowsPerPageOptions.indexOf(rowsPerPage) >= 0 ? rowsPerPageOptions.indexOf(rowsPerPage) : 0;
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);

    const handleRowsPerPageClick = e => {
        setAnchorEl(e.target);
    };

    const handleRowsSelected = e => {
        let value = e.target.value;
        onRowsPerPageSelected(value);
        let selectedIndex = rowsPerPageOptions.indexOf(value);
        setSelectedIndex(selectedIndex);
        handleClose()
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <RowsDropDownContainer>
            <IconButton href={null} size={"small"} onClick={handleRowsPerPageClick}>
                {rowsPerPage}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {
                    rowsPerPageOptions.map((rows, index) =>
                        <MenuItem
                            key={index}
                            selected={selectedIndex === index}
                            onClick={handleRowsSelected}
                            value={rows}
                            component={false} button={false}>
                            {rows}
                        </MenuItem>
                    )
                }
            </Menu>
        </RowsDropDownContainer>
    )
}

export default Pagination
